const getVideoDuration = async (url?: string): Promise<number> => {
  if (!url) return 0;

  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = encodeURI(url);

    video.onloadedmetadata = () => {
      const duration = Math.ceil(video.duration || 0);
      video.src = '';
      resolve(duration);
    };

    video.onerror = () => {
      video.src = '';
      resolve(0);
    };
  });
};

export default getVideoDuration;
